import * as React from 'react';
import { Component } from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  createSidebar,
  toggleSidebarCollapse,
  updateSidebar,
} from '../../redux/actions/general/sidebar';
import { setPlusActions } from '../../redux/actions/general/plus';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  dateTimeFrom,
  getURLParam,
  hasURLParam,
  redirect,
  setURLParam,
  setTableParams,
  validateForm,
} from '../../core/utils';
import Table from '../../components/Table';
import { deleteFolder, updateFolder } from '../../redux/actions/table/folders';
import {
  archiveFiles,
  downloadFiles,
  listFileFolders,
  listFiles,
  readFile,
  unlinkFileFromModule,
  unarchiveFiles,
  updateFileTags,
} from '../../redux/actions/table/files';
import styles from '../../styles/views/files/Files.scss';
import FolderClosedIcon from '../../assets/images/folder-closed-16x16.svg';
import FolderOpenedIcon from '../../assets/images/folder-opened-16x16.svg';
import FolderMoveIcon from '../../assets/images/move-to-folder.svg';
import TagIcon from '../../assets/images/tag-16x16.svg';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import LinkIcon from '../../assets/images/link-16x16.svg';
import AttachmentsIcon from '../../assets/images/attachments-16x16.svg';
import RestoreIcon from '../../assets/images/make-current-stage-15x15.svg';
import Tooltip from '../../components/Tooltip';
import TableNA from '../../components/TableNA';
import Image from '../../components/Image';
import Avatar from '../../components/Avatar';
import FilePreview from '../../components/FilePreview';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import { showLightbox } from '../../redux/actions/general/lightbox';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { colorOptions } from './colorOptions';
import FileFlyout from '../../flyouts/files/FileFlyout';

const MAX_FOLDER_DEPTH = 3;

const mapStateToProps = (state) => {
  return {
    table: state.table['files'],
    sidebar: state.general.sidebar,
  };
};

@connect(mapStateToProps)
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folders: [],
      unallocated_count: 0,
    };
  }

  _getSidebarExpanded(path) {
    const expanded = _.get(this.props.sidebar, path + '.expanded');

    return _.isUndefined(expanded) ? true : expanded;
  }

  _buildFolderTreeItems(folders, path, level = 1, index_offset = 0) {
    return _.map(folders, (folder, folder_index) => ({
      title: folder.title,
      count: folder.count,
      icon: FolderClosedIcon,
      expandedIcon: FolderOpenedIcon,
      iconColor: folder.color_hex,
      expanded: this._getSidebarExpanded(
        path + '.' + (folder_index + index_offset),
      ),
      onClick: () => this._setFolderFilter(this._getFolderIds(folder)),
      onArrowClick: !_.isEmpty(folder.children)
        ? () =>
            toggleSidebarCollapse(path + '.' + (folder_index + index_offset))
        : undefined,
      active: () => {
        const active_folders = _.split(getURLParam('filter.folder'), '|');
        const folder_ids = this._getFolderIds(folder);

        return !_.isEmpty(_.intersection(active_folders, folder_ids));
      },
      checkbox: {
        status: () => {
          const active_folders = _.split(getURLParam('filter.folder'), '|');
          const folder_ids = this._getFolderIds(folder);
          const intersected = _.intersection(active_folders, folder_ids);

          if (_.isEmpty(getURLParam('filter.folder'))) {
            return 'unchecked';
          }

          if (_.isEmpty(intersected)) {
            return 'unchecked';
          }

          return _.size(intersected) == _.size(folder_ids)
            ? 'checked'
            : 'neutral';
        },
        onClick: () => this._toggleFolderFilter(folder),
      },
      menuAction: {
        id: 'folder_' + folder.id,
        tooltip: __('Actions'),
        items: [
          {
            title: __('Folder colour'),
            color: folder.color_hex,
            colorOptions,
            selectedColor: folder.color_hex,
            onSelect: ({ hex }) => this._updateFolderColor(folder, hex),
          },
          {
            title: __('Add sub-folder'),
            onClick: () => this._openCreateFolderModal(folder.id),
            disabled: level >= MAX_FOLDER_DEPTH,
          },
          {
            title: __('Rename'),
            onClick: () => this._openRenameFolderModal(folder),
          },
          {
            title: __('Delete'),
            onClick: () => this._deleteFolder(folder),
          },
        ],
      },
      items: this._buildFolderTreeItems(
        folder.children || [],
        path + '.' + (folder_index + index_offset) + '.items',
        level + 1,
      ),
    }));
  }

  _updateFolderColor(folder, color_hex) {
    if (_.toLower(folder.color_hex) == _.toLower(color_hex)) {
      return;
    }

    updateFolder(this.props.match.params.stage, folder.id, { color_hex }).then(
      () => {
        this._reloadFolders();
        setNotification(__('Folder colour has been updated.'));
      },
    );
  }

  _deleteFolder(folder) {
    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __('This folder and its sub-folders will be deleted.'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteFolder(this.props.match.params.stage, folder.id).then(() => {
              hideAlertbox();
              this._removeFolderFromFilter(folder);
              this._reloadFolders();
              listFiles(this.props.match.params.stage);
              setNotification(__('Folder has been deleted.'));
            });
          },
        },
      ],
    });
  }

  _removeFolderFromFilter(folder) {
    const deleted_ids = _.map(
      [{ id: folder.id }, ...this._flattenFolders(folder.children || [])],
      (row) => _.toString(row.id),
    );

    const active_folders = _.split(getURLParam('filter.folder'), '|');
    const next = _.reject(active_folders, (id) => _.includes(deleted_ids, id));

    setURLParam('filter.folder', _.join(next, '|'));
  }

  _getFolderIds(folder) {
    return _.map(
      [{ id: folder.id }, ...this._flattenFolders(folder.children || [])],
      (row) => _.toString(row.id),
    );
  }

  _setFolderFilter(folder_ids) {
    setURLParam('filter.folder', _.join(_.uniq(folder_ids), '|'));
  }

  _toggleFolderFilter(folder) {
    const active_folders =
      getURLParam('filter.folder') == ''
        ? []
        : _.split(getURLParam('filter.folder'), '|');

    const folder_ids = this._getFolderIds(folder);
    const intersected = _.intersection(active_folders, folder_ids);
    let next = active_folders;

    if (_.size(intersected) == _.size(folder_ids)) {
      next = _.reject(active_folders, (row) => _.includes(folder_ids, row));
    } else {
      next = [...active_folders, ...folder_ids];
    }

    next = _.uniq(_.reject(next, (row) => row == 'n/a'));

    setURLParam('filter.folder', _.join(next, '|'));
  }

  _getUnallocatedSidebarItem() {
    const filter_value = 'unallocated';
    const is_active = () =>
      _.includes(_.split(getURLParam('filter.folder'), '|'), filter_value);

    return {
      title: __('Unallocated'),
      count: this.state.unallocated_count,
      icon: FolderClosedIcon,
      active: is_active,
      onClick: () => this._setFolderFilter([filter_value]),
      checkbox: {
        status: () => (is_active() ? 'checked' : 'unchecked'),
        onClick: () => {
          const active_folders = _.isEmpty(getURLParam('filter.folder'))
            ? []
            : _.split(getURLParam('filter.folder'), '|');
          const next = is_active()
            ? _.without(active_folders, filter_value)
            : [...active_folders, filter_value];

          setURLParam('filter.folder', _.join(_.uniq(next), '|'));
        },
      },
    };
  }

  _flattenFolders(folders = []) {
    return _.reduce(
      folders,
      (acc, row) => [
        ...acc,
        { id: row.id, title: row.title },
        ...this._flattenFolders(row.children || []),
      ],
      [],
    );
  }

  _getFoldersSidebarItems() {
    const folders_item_index = 0;
    const folder_path = 'items.' + folders_item_index;

    return [
      {
        title: __('Folders'),
        small_caps: true,
        icon: FolderClosedIcon,
        expandedIcon: FolderOpenedIcon,
        onClick: () => toggleSidebarCollapse(folder_path),
        expanded: this._getSidebarExpanded(folder_path),
        onArrowClick: () => toggleSidebarCollapse(folder_path),
        addAction: {
          tooltip: __('Add folder'),
          onClick: () => this._openCreateFolderModal(),
        },
        items: [
          ...this._buildFolderTreeItems(
            this.state.folders,
            folder_path + '.items',
            1,
            1,
          ),
          this._getUnallocatedSidebarItem(),
        ],
      },
    ];
  }

  _reloadFolders() {
    return listFileFolders(this.props.match.params.stage).then(
      ({ response }) => {
        this.setState(
          {
            folders: _.get(response, 'data.folders', []),
            unallocated_count: _.get(response, 'data.unallocated_count', 0),
          },
          () => {
            updateSidebar('items', this._getFoldersSidebarItems());
          },
        );
      },
    );
  }

  _openCreateFolderModal(parent_id = null) {
    setTableParams('files', {
      create_folder_wizard: {
        parent_id,
      },
    });
  }

  _openRenameFolderModal(folder) {
    setTableParams('files', {
      create_folder_wizard: {
        folder_id: folder.id,
        title: folder.title,
      },
    });
  }

  _openAttachFoldersWizard(file_ids) {
    if (_.isEmpty(this.state.folders)) {
      setNotification({
        text: __('No folders available. Create a folder first.'),
        type: 'warning',
      });
      return;
    }

    const selected_file_ids = _.map(file_ids, _.toString);
    const selected_files = _.filter(this.props.table.data, (file) =>
      _.includes(selected_file_ids, _.toString(file.id)),
    );
    const addSelectedCounts = (folders) =>
      _.map(folders, (folder) => ({
        ...folder,
        selected_count: _.filter(selected_files, (file) =>
          _.includes(
            _.map(file.folder_ids || [], _.toString),
            _.toString(folder.id),
          ),
        ).length,
        children: addSelectedCounts(folder.children || []),
      }));

    setTableParams('files', {
      attach_folders_wizard: {
        file_ids,
        folders: addSelectedCounts(this.state.folders),
      },
    });
  }

  _handleAttachFilesToFolder(file_ids) {
    if (_.isEmpty(this.state.folders)) {
      setNotification({
        text: __('No folders available. Create a folder first.'),
        type: 'warning',
      });
      return;
    }

    this._openAttachFoldersWizard(file_ids);
  }

  _handleMoveFilesToFolder(file_ids) {
    if (_.isEmpty(this.state.folders)) {
      setNotification({
        text: __('No folders available. Create a folder first.'),
        type: 'warning',
      });
      return;
    }

    setTableParams('files', {
      attach_folders_wizard: {
        file_ids,
        folders: this.state.folders,
        singleAction: true,
      },
    });
  }

  _isUnallocatedSelected() {
    const active_folders = _.reject(
      _.split(getURLParam('filter.folder'), '|'),
      _.isEmpty,
    );

    return _.isEqual(active_folders, ['unallocated']);
  }

  _selectedFiles(file_ids) {
    const selected_file_ids = _.map(file_ids, _.toString);

    return _.filter(this.props.table.data, (file) =>
      _.includes(selected_file_ids, _.toString(file.id)),
    );
  }

  _clearSelectedFiles() {
    setTableParams('files', {
      selected_rows: [],
    });
  }

  _refreshFilesAfterBulk() {
    const stage_id = this.props.match.params.stage;

    listFiles(stage_id);
    this._reloadFolders();

    if (this.props.table.clicked_row) {
      readFile(stage_id, this.props.table.clicked_row).catch(() =>
        setTableParams('files', {
          clicked_row: undefined,
          flyout: undefined,
        }),
      );
    }
  }

  _attachmentMenuRow(row) {
    return {
      ...row,
      attachment_id: row.id,
      title: row.file_name,
      name: row.file_name,
      ext: row.extension,
      creator: row.uploaded_by,
      created_at: row.uploaded_at,
      current_version_created_at: row.uploaded_at,
    };
  }

  _downloadFile(row, download = true) {
    const url = !download && row.stream_url ? row.stream_url : row.download_url;

    if (!url) {
      return;
    }

    setNotification(
      __('attachments.notification.download-started', {}, 'Download started.'),
    );
    window.open(url, '_blank');
  }

  _downloadFiles(file_ids) {
    const stage_id = this.props.match.params.stage;

    downloadFiles(stage_id, file_ids).then(({ response }) => {
      const queued = _.get(response, 'data.queued', 0);

      this._clearSelectedFiles();
      setNotification(
        queued
          ? __(
              'files.notification.zip-generation-started',
              {},
              'ZIP is being generated. You will receive a notification when it is ready.',
            )
          : {
              text: __(
                'files.notification.no-files-queued',
                {},
                'No selected files are available for download.',
              ),
              type: 'warning',
            },
      );
    });
  }

  _openEditAttachment(row) {
    const attachment = this._attachmentMenuRow(row);

    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: attachment,
      attachment_context: {
        type: 'files',
        stage_id: this.props.match.params.stage,
        attachment_id: attachment.attachment_id,
      },
    });
  }

  _openUploadAttachmentVersion(row) {
    const attachment = this._attachmentMenuRow(row);

    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: attachment,
      attachment_context: {
        type: 'files',
        stage_id: this.props.match.params.stage,
        attachment_id: attachment.attachment_id,
      },
    });
  }

  _openLinkFileToModelWizard(row) {
    hideDropdown();

    this._openLinkFilesToModelWizard([row.id], [row], () => {
      listFiles(this.props.match.params.stage);
      return readFile(this.props.match.params.stage, row.id);
    });
  }

  _openLinkFilesToModelWizard(file_ids, files = null, onLinked = null) {
    const selected_files = files || this._selectedFiles(file_ids);

    setAttachmentParams({
      link_file_to_model_wizard: {
        stage_id: this.props.match.params.stage,
        file: _.head(selected_files),
        files: selected_files,
        file_ids,
        onLinked: () => {
          this._clearSelectedFiles();

          if (onLinked) {
            return onLinked();
          }

          listFiles(this.props.match.params.stage);
        },
      },
    });
  }

  _archiveFiles(file_ids, restore = false) {
    const stage_id = this.props.match.params.stage;
    const action = restore ? unarchiveFiles : archiveFiles;

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: restore
        ? __(
            'files.alert.restore-selected-files',
            {},
            'Are you sure you want to restore selected files?',
          )
        : __(
            'files.alert.archive-selected-files',
            {},
            'Are you sure you want to archive selected files?',
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: restore
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            action(stage_id, file_ids).then(() => {
              hideAlertbox();
              this._clearSelectedFiles();
              this._refreshFilesAfterBulk();
              setNotification(
                restore
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.',
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.',
                    ),
              );
            });
          },
        },
      ],
    });
  }

  _updateFileTags(row, tags) {
    const stage_id = this.props.match.params.stage;

    return validateForm(
      updateFileTags(stage_id, row.id, tags).then(() => {
        listFiles(stage_id);
        readFile(stage_id, row.id);
        setNotification(__('File tags have been saved.'));
      }),
    );
  }

  _unlinkFile(row, source) {
    const stage_id = this.props.match.params.stage;

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'files.flyout.unlink-confirmation',
        {},
        'Are you sure you want to unlink this file from the selected item?',
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-unlink', {}, 'Yes, unlink'),
          onClick: () => {
            unlinkFileFromModule(stage_id, row.id, source.link_id).then(() => {
              hideAlertbox();
              setNotification(
                __('files.flyout.unlinked', {}, 'File link removed.'),
              );
              listFiles(stage_id);
              this._reloadFolders();
              readFile(stage_id, row.id).catch(() =>
                setTableParams('files', {
                  clicked_row: undefined,
                  flyout: undefined,
                }),
              );
            });
          },
        },
      ],
    });
  }

  _archiveAttachment(row) {
    const attachment_id = row.id;
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?',
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?',
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.',
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.',
                    ),
              );
              listFiles(this.props.match.params.stage);
              readFile(this.props.match.params.stage, attachment_id);
            });
          },
        },
      ],
    });
  }

  _deleteFile(row) {
    const attachment_id = row.id;

    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'files.general.alert.want-delete-file.process-cannot-undone',
        {},
        'Are you sure you want to delete this file? This action cannot be undone.',
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                __('files.notification.file-deleted', {}, 'File deleted.'),
              );
              listFiles(this.props.match.params.stage);
              this._reloadFolders();
              setTableParams('files', {
                clicked_row: undefined,
                flyout: undefined,
              });
            });
          },
        },
      ],
    });
  }

  _renderFileMenu(row) {
    const menu_row = this._attachmentMenuRow(row);

    return (
      <AttachmentFileMenu
        compact
        name={'files_file_menu_' + row.id}
        row={menu_row}
        onDownloadFile={(item, download) => this._downloadFile(item, download)}
        onOpenEdit={(item) => this._openEditAttachment(item)}
        onOpenUploadVersion={(item) => this._openUploadAttachmentVersion(item)}
        onArchiveAttachment={(item) => this._archiveAttachment(item)}
        onDeleteFile={(item) => this._deleteFile(item)}
        onAddToFolders={(item) =>
          this._handleAttachFilesToFolder([item.attachment_id])
        }
      />
    );
  }

  componentDidMount() {
    enableProjectsDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/files'),
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/files'),
    );

    createSidebar({
      title: __('submenu.title.files'),
      items: this._getFoldersSidebarItems(),
    });

    if (!hasURLParam('filter.folder')) {
      setURLParam('filter.folder', '');
    }

    this._reloadFolders();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        setTableParams('files', { flyout: undefined });
      }

      readFile(this.props.match.params.stage, this.props.table.clicked_row);
    }

    //if there are new filter options available, update sidebar
    if (!_.isEqual(this.props.table.filters, prevProps.table.filters)) {
      updateSidebar('items', this._getFoldersSidebarItems());
    }

    if (
      prevProps.table.create_folder_wizard &&
      !this.props.table.create_folder_wizard
    ) {
      this._reloadFolders();
    }

    if (
      this.props.table.folders_reload_at &&
      this.props.table.folders_reload_at !== prevProps.table.folders_reload_at
    ) {
      this._reloadFolders();
    }
  }

  _handleOpacity(value, row) {
    return row.archived ? <div className={styles.hidden}>{value}</div> : value;
  }

  render() {
    const lightbox_images = _.map(
      _.filter(this.props.table.data, (file) =>
        _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.extension)),
      ),
      (file) => ({
        id: file.id,
        attachment_version_id: file.attachment_version_id,
        stream_url: file.stream_url,
        title: [file.file_name, file.extension].join('.'),
        download_url: file.download_url,
        ext: file.extension,
        width: file.width,
        height: file.height,
      }),
    );
    const openFilePreview = (row) => {
      if (
        _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(row.extension))
      ) {
        showLightbox(lightbox_images, row.id);
      } else {
        this._downloadFile(row);
      }
    };

    const columns = [
      {
        key: 'thumbnail_url',
        name: __('files.table.thumbnail'),
        value: (value, row) =>
          this._handleOpacity(
            value ? (
              <Tooltip
                placement='right'
                text={<Image className={styles.thumbPreview} src={value} />}
                html={true}
                dark={true}
              >
                <span
                  className={classNames(
                    _.includes(
                      ['jpg', 'jpeg', 'png', 'pdf'],
                      _.toLower(row.extension),
                    ) && styles.thumbClickable,
                  )}
                  onClick={(e) => {
                    e.stopPropagation();
                    openFilePreview(row);
                  }}
                >
                  <Image className={styles.thumb} src={value} />
                </span>
              </Tooltip>
            ) : (
              <span
                className={classNames(
                  styles.filePreview,
                  styles.thumbClickable,
                )}
              >
                <FilePreview
                  row={this._attachmentMenuRow(row)}
                  lightbox_images={lightbox_images}
                  onDownloadFile={() => this._downloadFile(row)}
                  fileName={false}
                  customStyles={styles.tableFilePreview}
                />
              </span>
            ),
            row,
          ),
        width: 50,
        sortable: false,
      },
      {
        key: 'file_name',
        name: __('files.table.file-name'),
        required: true,
        value: (value, row) => this._handleOpacity(value, row),
        mobileVisible: true,
        width: 250,
      },
      {
        key: 'extension',
        name: __('files.table.type'),
        value: (value, row) =>
          this._handleOpacity(
            <span className={styles.fileType}>{_.toUpper(value)}</span>,
            row,
          ),
        width: 90,
        sortable: false,
      },
      {
        key: 'version',
        name: __('files.table.version'),
        value: (value, row) => (
          <span className={styles.version}>
            {row.archived
              ? __('attachments.menu.archived', {}, 'Archived')
              : 'V' + value}
          </span>
        ),
        width: 100,
      },
      {
        key: 'sources',
        name: __('files.table.linked-to'),
        value: (sources, row) => {
          const source = _.head(sources);

          if (!source) {
            return <TableNA />;
          }

          const visible_sources = _.take(sources, 4);

          const sources_label = _.map(
            visible_sources,
            (item) => item.code || item.title,
          ).join(', ');

          const sources_tooltip = _.map(visible_sources, (item) =>
            _.filter([item.code, item.title]).join(': '),
          ).join(', ');

          const more_tooltip = _.map(_.slice(sources, 4), (item) =>
            _.filter([item.code, item.title]).join(': '),
          ).join(', ');

          return (
            <div className={styles.linkedSources}>
              <Tooltip text={sources_tooltip}>
                <span className={styles.linkedTo}>{sources_label}</span>
              </Tooltip>

              {_.size(sources) > 4 && (
                <Tooltip text={more_tooltip}>
                  <div className={styles.more}>
                    <span>+ {_.size(sources) - 4}</span>
                  </div>
                </Tooltip>
              )}
            </div>
          );
        },
        sortable: false,
        //width: 300,
      },
      {
        key: 'folders',
        name: __('files.table.location', {}, 'Location'),
        value: (folders, row) => {
          const folder = _.head(folders);

          if (!folder) {
            return __('Unallocated');
          }

          const visible_folders = _.take(folders, 4);
          const folders_label = _.map(visible_folders, 'location').join(', ');
          const folders_tooltip = _.map(visible_folders, 'location').join(', ');
          const more_tooltip = _.map(_.slice(folders, 4), 'location').join(
            ', ',
          );

          return this._handleOpacity(
            <div className={styles.linkedSources}>
              <Tooltip text={folders_tooltip}>
                <span className={styles.linkedTo}>{folders_label}</span>
              </Tooltip>

              {_.size(folders) > 4 && (
                <Tooltip text={more_tooltip}>
                  <div className={styles.more}>
                    <span>+ {_.size(folders) - 4}</span>
                  </div>
                </Tooltip>
              )}
            </div>,
            row,
          );
        },
        sortable: false,
      },
      {
        key: 'uploaded_by',
        width: 50,
        name: __('files.table.uploaded-by'),
        value: (user, row) =>
          user
            ? this._handleOpacity(
                <div className={styles.uploadedBy}>
                  <Avatar
                    avatar_url={user.avatar_url}
                    name={user.name}
                    size={24}
                  />
                </div>,
                row,
              )
            : null,
        width: 50,
        sortable: false,
      },
      {
        key: 'uploaded_at',
        name: __('files.table.uploaded-at'),
        default: true,
        desc: true,
        value: (value, row) =>
          this._handleOpacity(value ? dateTimeFrom(value) : null, row),
        width: 145,
      },
      {
        key: 'file_actions',
        name: '',
        required: true,
        value: (_value, row) => this._renderFileMenu(row),
        width: 50,
        sortable: false,
      },
    ];

    const groupActions = (file_ids) => {
      const selected_files = this._selectedFiles(file_ids);
      const active_file_ids = _.map(
        _.filter(selected_files, (file) => !file.archived),
        'id',
      );
      const archived_file_ids = _.map(
        _.filter(selected_files, (file) => file.archived),
        'id',
      );

      return [
        <Tooltip
          text={__(
            'files.group.download-selected',
            {},
            'Download selected files',
          )}
          key='download'
        >
          <DownloadIcon
            onClick={(e) => {
              e.stopPropagation();
              this._downloadFiles(file_ids);
            }}
          />
        </Tooltip>,
        <Tooltip
          text={__('files.group.link-selected', {}, 'Link selected files')}
          key='link'
        >
          <LinkIcon
            onClick={(e) => {
              e.stopPropagation();
              this._openLinkFilesToModelWizard(file_ids);
            }}
          />
        </Tooltip>,
        !_.isEmpty(active_file_ids) && (
          <Tooltip
            text={__(
              'files.group.archive-selected',
              {},
              'Archive selected files',
            )}
            key='archive'
          >
            <AttachmentsIcon
              onClick={(e) => {
                e.stopPropagation();
                this._archiveFiles(active_file_ids);
              }}
            />
          </Tooltip>
        ),
        !_.isEmpty(archived_file_ids) && (
          <Tooltip
            text={__(
              'files.group.restore-selected',
              {},
              'Restore selected files',
            )}
            key='restore'
          >
            <RestoreIcon
              onClick={(e) => {
                e.stopPropagation();
                this._archiveFiles(archived_file_ids, true);
              }}
            />
          </Tooltip>
        ),
        <Tooltip text={__('Add selected files to folders')} key='folders'>
          <FolderOpenedIcon
            onClick={(e) => {
              e.stopPropagation();
              this._handleAttachFilesToFolder(file_ids);
            }}
          />
        </Tooltip>,
        this._isUnallocatedSelected() && (
          <Tooltip text={__('Move selected files to folder')} key='move'>
            <FolderMoveIcon
              onClick={(e) => {
                e.stopPropagation();
                this._handleMoveFilesToFolder(file_ids);
              }}
            />
          </Tooltip>
        ),
        <Tooltip text={__('Multiple edit file tags')} key='tags'>
          <TagIcon
            onClick={(e) => {
              e.stopPropagation();

              setTableParams('files', {
                wizard_multiple_file_tags_edit: file_ids,
              });
            }}
          />
        </Tooltip>,
      ];
    };

    const gridOptions = {
      section: 'Files',
      image: (id, row) => row.thumbnail_url,
      title: (row) =>
        this._handleOpacity(
          (row.file_name || '') +
            (row.archived ? ' (' + __('Archived') + ')' : ''),
          row,
        ),
      subTitle: (row) =>
        _.filter([
          _.toUpper(row.extension),
          row.version ? 'V' + row.version : null,
        ]).join(' · '),
      content: (row) => [row.description],
      rightTitle: (row) => this._renderFileMenu(row),
    };

    const preview = this.props.table.flyout ? (
      <FileFlyout
        data={this.props.table.flyout}
        onDownload={(row, download) => this._downloadFile(row, download)}
        onOpenEdit={(row) => this._openEditAttachment(row)}
        onOpenUploadVersion={(row) => this._openUploadAttachmentVersion(row)}
        onOpenLink={(row) => this._openLinkFileToModelWizard(row)}
        onArchive={(row) => this._archiveAttachment(row)}
        onUnlink={(row, source) => this._unlinkFile(row, source)}
        onUpdateTags={(row, tags) => this._updateFileTags(row, tags)}
      />
    ) : (
      []
    );

    return (
      <Table
        listAction={() => listFiles(this.props.match.params.stage)}
        name='files'
        title={__('submenu.title.files')}
        columns={columns}
        customSingleActions={true}
        gridOptions={gridOptions}
        groupActions={groupActions}
        defaultView='list'
        preview={preview}
        onLoad={() => {
          listActiveModules().then(() => {
            setPlusActions([
              {
                title: __('files.add-files-wizard.title'),
                onClick: () =>
                  setTableParams('files', {
                    wizard_active: true,
                  }),
              },
            ]);
          });
        }}
      />
    );
  }
}

export default Files;
